import { Box, Flex, Image, Text } from "@chakra-ui/react";
import SearchingLoader from "@root/components/loader/SearchingLoader";
import { RESPONSE_STATUS } from "@root/constants";
import { useTranslation } from "react-i18next";
import SearchIcon from "@assets/icons/search-icon2.svg";
import { useMainChatContext } from "@root/context/kps-chat-context";

const RenderStatus = ({
  currentMessageResponse,
  currentStatus,
  chat,
  isSearchProcessing,
  isWebProcessing,
  isFileProcessing,
  isYoutubeProcessing,
  isDeepSearchProcessing,
}: any) => {
  const { t } = useTranslation("common");
  const searchStatus =
    chat?.meta?.c?.search_status || chat?.meta?.search_status;
  const webpageStatus = currentMessageResponse?.webpage_status;
  const fileStatus = currentMessageResponse?.file_status;
  const youtubeStatus = currentMessageResponse?.youtube_status;
  const searchQuery = chat?.meta?.c?.search_query || chat?.meta?.search_query;
  const { setSelectedChat } = useMainChatContext();

  function renderLoader(title: string) {
    return (
      <Box marginTop={"15px"}>
        <SearchingLoader title={title} />
      </Box>
    );
  }

  function renderStatus() {
    if (currentStatus === "start") {
      let title = "";
      if (isSearchProcessing) {
        title = t("chat.searching");
        return renderLoader(title);
      } else if (isWebProcessing) {
        title = t("chat.scraping"); // when webpageStatus === 1
        if (webpageStatus === 2) {
          title = t("chat.summarizing");
        }
        return renderLoader(title);
      } else if (isFileProcessing) {
        title = t("chat.downloadingFile"); // when fileStatus === 1
        if (fileStatus === 2) {
          title = t("chat.parsingFile");
        }
        return renderLoader(title);
      } else if (isYoutubeProcessing) {
        title = t("chat.extractingTitle"); // when youtubeStatus === 1
        if (youtubeStatus === 2) {
          title = t("chat.extractingTranscript");
        } else if (youtubeStatus === 3) {
          title = t("chat.extractingTableOfContents");
        }
        return renderLoader(title);
      } else if (isDeepSearchProcessing) {
        title = t("chat.extractingLogs"); // when deepSearchStatus === 1
        return renderLoader(title);
      }
    }
  }

  function renderSourcesHead() {
    if (searchQuery)
      return (
        <Flex
          backgroundColor={"#F1F6F9"}
          borderRadius={"20px"}
          py={"6px"}
          px={"10px"}
          justifyContent={"space-between"}
          gap={"20px"}
          alignItems={"center"}
        >
          <Flex alignItems={"center"}>
            <Image src={SearchIcon} alt="search-icon" />
            {/* <Text
              fontSize={"14px"}
              color={"#798692"}
              marginLeft={"15px"}
              marginRight={"30px"}
              whiteSpace={"nowrap"}
            >
              {t("chat.search1")}
            </Text> */}
            <Text color={"#798692"} pl={"10px"} fontWeight={500}>
              {searchQuery || ""}
            </Text>
          </Flex>
          {/* {searchStatus === 2 && (
            <Box
              fontWeight={500}
              fontSize={"12px"}
              color={"#000000"}
              borderRadius={"16px"}
              backgroundColor={"#CDD6DC"}
              px={"12px"}
              py={"6px"}
              cursor={"pointer"}
              onClick={() => {
                setSelectedChat(chat);
              }}
              whiteSpace={"nowrap"}
            >
              {t("chat.view")}
            </Box>
          )} */}
        </Flex>
      );
  }

  return (
    <Box>
      {renderSourcesHead()}
      {renderStatus()}
    </Box>
  );
};

export default RenderStatus;
